// extracted by mini-css-extract-plugin
export var wordContainer = "_pi-0";